<template>
    <div class="participant-metrics-chart-box-plot">
        <highcharts :options="chartOptions"></highcharts>
    </div>
</template>

<script>

import Vue from 'vue'
import * as _ from 'lodash'
import moment from 'moment'
import Highcharts from 'highcharts'
import GaugeColors from '@/providers/GaugeColors'

export default Vue.extend({
    name: "ParticipantMetricsChartBoxPlot",
    props: {
        metrics: Array,
        metricTop: String,
        metricBottom: String,
        dateRange: Object
    },
    data() {
        return {}
    },
    computed: {
        /**
         * Consolidates readings from all services into single arrays,
         * one for top, and one for bottom metric.
         * Sorts each of these by date.
         */
        readings() {
            let compareFn = (a, b) => {
                return new Date(a.value.dateTime) - new Date(b.value.dateTime)
            }

            let top = _.reduce(this.metrics, (readings, metric) => {
                if (metric.metric === this.metricTop) {
                    readings = readings.concat(metric.readings)
                }
                return readings
            }, []).sort(compareFn)

            let bottom = _.reduce(this.metrics, (readings, metric) => {
                if (metric.metric === this.metricBottom) {
                    readings = readings.concat(metric.readings)
                }
                return readings
            }, []).sort(compareFn)

            //Filter by date range
            if (this.dateRange && this.dateRange.from && this.dateRange.to) {
                const dateFrom = this.dateRange.from
                const dateTo = this.dateRange.to
                top = _.filter(top, reading => {
                    return (reading.value.dateTime >= dateFrom) && (reading.value.dateTime <= dateTo)
                })
                bottom = _.filter(bottom, reading => {
                    return (reading.value.dateTime >= dateFrom) && (reading.value.dateTime <= dateTo)
                })
            }

            return [top, bottom]
        },
        chartOptions() {
            const options = this.getBaseOptions()
            this.addMetricOptions(options)
            return options
        }
    },
    methods: {
        getBaseOptions() {
            Highcharts.setOptions({lang: {thousandsSep: ','}})
            return {
                chart: {
                    borderColor: '#fff',
                    borderWidth: 4,
                    // type: 'columnrange',
                    type: 'line',
                    height: (this.$mq == 'sm' ? '80%' : '50%'),
                    showAxes: false,
                    backgroundColor: '#eee',
                    plotBackgroundColor: '#eee',
                    margin: 40,
                },
                title: null,
                credits: {enabled: false},
                tooltip: {enabled: true},
                legend: {enabled: false},

                plotOptions: {
                    columnrange: {
                        color: `rgb(128, 128, 128, 1)`,
                        marker: {
                            symbol: 'circle',
                            radius: 3,
                        },
                        tooltip: {
                            pointFormat: this.pointFormat
                        },
                        dataLabels: {
                            enabled: true
                        }
                    }
                },

                xAxis: {
                    visible: false,
                    type: 'datetime',
                },

                yAxis: {
                    gridLineWidth: 0,
                    labels: {
                        align: 'left',
                        x: -30
                    },
                    title: null,
                },
                series: [
                    {
                        name: 'Systolic',
                        data: [],
                        color: GaugeColors.METRIC_SERIES_COLORS[0]
                    },
                    {
                        name: 'Diastolic',
                        data: [],
                        color: GaugeColors.METRIC_SERIES_COLORS[1]
                    },
                ]
            }
        },
        addMetricOptions(options) {
            let sysReadings = this.readings[0].map((reading) => {
                return parseFloat(reading.value.value)
            })
            let diaReadings = this.readings[1].map((reading) => {
                return parseFloat(reading.value.value)
            })
            let dates = this.readings[0].map((reading) => {
                return Date.parse(reading.value.dateTime)
            })

            //console.log('ParticipantMetricsChartBoxPlot:addMetricOptions  [SYS READING]', sysReadings)
            //console.log('ParticipantMetricsChartBoxPlot:addMetricOptions  [DIA READING]', diaReadings)
            //console.log('ParticipantMetricsChartBoxPlot:addMetricOptions  [DATES]', dates)

            for (let i = 0; i < sysReadings.length; i++) {
                options.series[0].data[i] = {
                    x: dates[i],
                    y: sysReadings[i]
                }
                options.series[1].data[i] = {
                    x: dates[i],
                    y: diaReadings[i]
                }
            }

        }

    }
})
</script>

<style scoped>

</style>
